(function ($, Drupal) {
  function insertNodeLocation($el, $progress) {
    if ($el.length == 0) return;
    $el[0].$throbber = $progress;
    let inserRole = {
      before: ($ele = $el) => $ele.before($progress),
      after: ($ele = $el) => $ele.after($progress),
      prepend: ($ele = $el) => $ele.prepend($progress),
      append: ($ele = $el) => $ele.append($progress),
      parentPrepend: ($ele = $el) => $ele.parent().prepend($progress),
      parentAppend: ($ele = $el) => $ele.parent().append($progress),
    };
    if ($el.hasClass('mdc-button')) {
      inserRole.prepend();
    } else if ($el.hasClass('webform-select2')) {
      inserRole.after();
    } else if ($el.hasClass('form-select')) {
      inserRole.after($el.closest('.mdc-select--outlined').find('.mdc-notched-outline'));
    } else if ($el.hasClass('button-submit__input')) {
      inserRole.parentPrepend();
    } else {
      inserRole.after();
    }
  }

  function getDomAndJqueryDom(el) {
    if (!el) return;
    let $el;
    if (el instanceof Element) {
      $el = $(el);
    } else if (el instanceof $) {
      $el = el;
      el = $el[0];
    }
    return [el, $el];
  }

  function eleSetThrobber(el, autoRemoveOption = { delay: 0, callback: undefined }) {
    if (!el) return;
    let oEl = el;
    let $el;
    [el, $el] = getDomAndJqueryDom(el);
    $el.addClass('pe-none');
    if (!el.$throbber) {
      el.$throbber = $(throbber());
      insertNodeLocation($el, el.$throbber);
    }
    let { delay, callback } = autoRemoveOption;
    if (delay) {
      setTimeout(function () {
        eleRemoveThrobber(el);
        callback && callback.apply(oEl);
      }, delay);
    }
  }

  function eleRemoveThrobber(el) {
    if (!el) return;
    let $el;
    [el, $el] = getDomAndJqueryDom(el);
    $el.removeClass('pe-none');
    if (el.$throbber) {
      el.$throbber.remove();
      delete el.$throbber;
    }
  }

  /* if (!$.elfn) $.elfn = {};
  $.extend($.elfn, {
    eleSetThrobber,
    eleRemoveThrobber,
    throbber,
  }); */

  if (Drupal.Ajax) {
    //js处理ajax 多级下拉框下拉框隐藏（例：GEO更改国家，隐藏省市区）
    let beforeSend = Drupal.Ajax.prototype.beforeSend;
    Drupal.Ajax.prototype.beforeSend = function (response, status) {
      console.log('Drupal.Ajax.prototype.beforeSend', { response, status });
      /*  let $el = $(this.element);
      if ($el.data('como-trigger-element')) {
        $el = $el.data('como-trigger-element');
      }
      if ($el && $el.is('select')) {
        let $gridCell = $el.closest('.mdc-layout-grid__cell');
        if ($gridCell.length) {
          $gridCell.nextAll().hide();
        }
      } */
      return beforeSend.apply(this, [response, status]);
    };

    /* Drupal.Ajax.prototype.setProgressIndicatorThrobber = function () {
      this.progress.element = $(Drupal.theme('ajaxProgressThrobber'));
      let $el = $(this.element);
      if ($el.data('como-trigger-element')) {
        $el = $el.data('como-trigger-element');
      }
      insertNodeLocation($el, this.progress.element);
    }; */
    /**
     * Sets the throbber progress indicator.
     */
    let setProgressIndicatorThrobber = Drupal.Ajax.prototype.setProgressIndicatorThrobber;
    Drupal.Ajax.prototype.setProgressIndicatorThrobber = function () {
      console.log('this.progress.message', this.progress.message);
      return setProgressIndicatorThrobber.apply(this);
      /* this.progress.element = $(Drupal.theme('ajaxProgressThrobber', this.progress.message));
      if ($(this.element).closest('[data-drupal-ajax-container]').length) {
        $(this.element).closest('[data-drupal-ajax-container]').after(this.progress.element);
      } else {
        $(this.element).after(this.progress.element);
      } */
    };
  }
})(jQuery, Drupal);
